import { css } from "@emotion/react";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomScrollbars } from "../components/CustomScrollbars/CustomScrollbars";
import { RegisterForm } from "../components/RegisterForm";
import { SiteLayout } from "../components/SiteLayout";
import { AppConstants } from "../data/AppConstants";
import { useRegisterFormState } from "../hooks/useRegisterFormState";

//export type RegisterPageProps = {};
export const RegisterPage: React.FC /*<RegisterPageProps>*/ = () => {
	const registerFormState = useRegisterFormState();
	const location = useLocation();
	const navigate = useNavigate();
	const redirectParam = new URLSearchParams(location.search).get("redirect");
	const redirectPath =
		redirectParam?.startsWith("/") && !redirectParam.startsWith("//")
			? redirectParam
			: "/";

	return (
		<SiteLayout
			title={registerFormState.translate("Register")}
			mainChildren={
				<CustomScrollbars className="flex-1 flex items-center justify-center">
					<div
						className={`flex-1 mx-auto flex items-center justify-center]`}
						css={css`max-width:${AppConstants.siteWidthCss};`}
					>
						<RegisterForm
							registerFormState={registerFormState}
							onRegistered={() => {
								navigate(redirectPath, { replace: true });
							}}
						/>
					</div>
				</CustomScrollbars>
			}
		/>
	);
};
